"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filter = void 0;
var _react = _interopRequireDefault(require("react"));
var _Forms = require("../Forms");
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./style.css");
const Filter = props => {
  const {
    children,
    defaultValues
  } = props;
  const submitFormData = formData => {
    const {
      updateFilteredData
    } = props;
    const filteredFormData = Object.keys(formData).filter(item => formData[item]);
    const formUrlParams = filteredFormData.map(element => {
      /* For multiselect */
      if (Array.isArray(formData[element])) {
        return {
          key: element,
          value: formData[element].map(el => el.value).toString()
        };
      } else if (!Array.isArray(formData[element])) {
        /* For single select */
        return {
          key: element,
          value: formData[element].value
        };
      }
      /* For input elements */
      return {
        key: element,
        value: formData[element]
      };
    });
    updateFilteredData(formUrlParams);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-heading"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Filters")), /*#__PURE__*/_react.default.createElement(_Forms.Form, {
    onSubmit: formData => {
      return submitFormData(formData);
    },
    submitButtonText: "Apply",
    submitButtonStyle: "secondary",
    defaultValues: defaultValues,
    submitOnCancel: true,
    hideShowButton: true,
    cancelButtonText: "Reset",
    cancelButtonStyle: "link",
    isUserAuthenticated: () => 'false' /* Prevent formDirtyState on route change */
  }, children)));
};
exports.Filter = Filter;
Filter.defaultProps = {
  children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null),
  defaultValues: {},
  updateFilteredData: () => {}
};
Filter.propTypes = {
  children: _propTypes.default.array,
  defaultValues: _propTypes.default.object,
  updateFilteredData: _propTypes.default.func
};